var OrgTypes = require("lib/academic/OrgTypes");

var ReadingSelectors = require("lib/selectors/ReadingSelectors");

var SelectorUtility = require("lib/shared/SelectorUtility");

var Queries = require("lib/shared/Queries");

//////////////////////////////////////////////
// Admins ////////////////////////////////////
////////////////////-//////////////////////////

export function isLoadingAdmins({ state, key }) {
	key = key || "index";
	return state.admins.loading[key];
}

// Gets all admins (sorted by name)
export function admins({ state, filters, conditions }) {
	var admins = SelectorUtility.filterBy(state.admins, filters, conditions);
	return _.sortBy(admins, "last_name");
};

export function admin({ state, id }) {
	return state.admins[id];
}

// Gets all students (sorted by name) with the provided student list ID
export function primaryAdminForStudentListID({ state, studentListID }) {
	if (!(studentListID in state.studentLists)) { return []; }

	var admin = null;

	_.each(admins({ state }), (a) => {

		if (a.org_ids) {
			// Method used by teachers, admins
			if (a.org_ids.student_lists.primary.includes(studentListID)) {
				admin = a;
			}
		}
	});
	
	return admin;
}


//////////////////////////////////////////////
// Avatars ///////////////////////////////////
//////////////////////////////////////////////

export function avatar({ state, id }) {
	return state.avatars[id];
}
export function avatarForStudent({ state, studentID }) {
	var st = student({ state, id: studentID });
	if (st && st.avatar) {
		return state.avatars[st.avatar];
	}
}

//////////////////////////////////////////////
// CoinRecords ///////////////////////////////
//////////////////////////////////////////////

// Gets all students (sorted by name)
export function coinRecordsForSubject({ state, subjectType, subjectID }) {
	if (subjectType == "Quiz") {
		var coldRecordIDs = state.quizzes[subjectID].gold_records;
	} else if (subjectType == "Answer") {
		var coldRecordIDs = state.answers[subjectID].gold_records;
	}

	if (!coldRecordIDs) { return []; };

	return _.values(_.pick(state.coinRecords, coldRecordIDs));

};

//////////////////////////////////////////////
// DistrictOrgs ////////////////////////////////
//////////////////////////////////////////////

export function districtOrg({ state, id }) {
	return state.districtOrgs[id];
}

export function districtOrgs({ state, filters, conditions, filterEmpty }) {
	var useDistrictOrgs = SelectorUtility.filterBy(state.districtOrgs, filters, conditions)

	return _.sortBy(useDistrictOrgs, "name")
}

export function isLoadingDistrictOrgs({ state, key }) {
	key = key || "index";
	return state.districtOrgs.loading[key];
}

export function districtOrgsTotal({ state, conditions, filters }) {
	var query = Queries.toQuery(filters, conditions);
	var totalKey = $wr.sortedJSON(query);
	return state.districtOrgs.totals[totalKey];
}

export function districtOrgsPaginated({ state, conditions, filters, page }) {
	var query = Queries.toQuery(filters, conditions);
	var pageKey = $wr.sortedJSON(query);
	return SelectorUtility.selectPage(state.districtOrgs, pageKey, page);
}


//////////////////////////////////////////////
// Prefs /////////////////////////////////////
//////////////////////////////////////////////
export function districtOrgPrefs({ state, districtOrgID }) {
	var useDistrictOrg = districtOrg({ state, id: districtOrg });
	
	return (useDistrictOrg || {}).prefs;
}

export function schoolOrgPrefs({ state, schoolOrgID }) {
	var useSchoolOrg = schoolOrg({ state, id: schoolOrgID });
	
	return (useSchoolOrg || {}).prefs;
}

export function studentListPrefs({ state, studentListID }) {
	if (studentListID) {
		var useStudentList = studentList({ state, id: studentListID });
	} else {
		var useStudentList = studentLists({ state }).filter(x => x.prefs)[0];
	}
	return (useStudentList || {}).prefs;
}

export function globalStudentListPrefs({ state, }) {
	return studentListPrefs({ state }) || {};
}

//////////////////////////////////////////////
// StudentLists //////////////////////////////
//////////////////////////////////////////////

// Gets all student lists (sorted by name)
export function studentLists({ state, filters, conditions, filterEmpty }) {
	var studentLists = SelectorUtility.filterBy(state.studentLists, filters, conditions)

	// Option to return only students lists with students
	if (filterEmpty) {
		var slIDs = _.uniq(_.compact(_.flatten(students({ state }).map((s) => {
			if (s.student_list_ids) {
				return s.student_list_ids.all
			}
		}))));
		studentLists = _.filter(studentLists, (sl) => slIDs.includes(sl.id));
	}
	return _.sortBy(studentLists, "name")
};

// Gets all student lists associated to an admin
// Student Lists must be loaded into state with the 'student_list.admins' embed
export function studentListsByAdminId({ state, adminId, filters, conditions, filterEmpty }) {

	var allStudentLists = studentLists({ state, filters, conditions, filterEmpty })

	var admin = state.admins[adminId];

	if (admin) {
		if (admin.role == 'districtAdminRole') {
			var filteredStudentLists = allStudentLists
		}
		else if (admin.role == 'adminRole') {

			var schoolOrgIDs = admin.org_ids.school_orgs.all || []
			var filteredStudentLists = _.filter(allStudentLists, (sl) => {
				if (sl.school_org_id) {
					return _.includes(schoolOrgIDs, sl.school_org_id)
				}
			})
		}
		else if (admin.role == 'teacherRole') {
			var filteredStudentLists = _.filter(allStudentLists, (sl) => {
				var adminIds = sl.admin_ids ? sl.admin_ids : []
				if (sl.admins) {
					adminIds = _.map(sl.admins, (a) => a.id)
				}
				if (adminIds.length > 0) {
					return _.includes(adminIds, adminId)
				}
			})
		}
	}




	return filteredStudentLists
};

export function studentList({ state, id }) {
	return state.studentLists[id];
}

export function nonEmptyStudentLists({ state }) {
	return studentLists({ state, filterEmpty: true });
}

export function isLoadingStudentLists({ state, key }) {
	key = key || "index";
	return state.studentLists.loading[key];
}

//////////////////////////////////////////////
// SchoolOrgs ////////////////////////////////
//////////////////////////////////////////////

export function schoolOrg({ state, id }) {
	return state.schoolOrgs[id];
}

export function schoolOrgs({ state, filters, conditions, filterEmpty }) {
	var schoolOrgs = SelectorUtility.filterBy(state.schoolOrgs, filters, conditions)

	if (filterEmpty) {
		schoolOrgs = schoolOrgs.filter(
			x => studentsForSchoolOrgID({ state, schoolOrgID: x.id }).length
		);
	}

	return _.sortBy(schoolOrgs, "name")
}

export function nonEmptySchoolOrgs({ state }) {
	return schoolOrgs({ state, filterEmpty: true });
}

export function isLoadingSchoolOrgs({ state, key }) {
	key = key || "index";
	return state.schoolOrgs.loading[key];
}

export function schoolOrgsPaginated({ state, conditions, filters, page }) {
	var query = Queries.toQuery(filters, conditions);
	var pageKey = $wr.sortedJSON(query);
	return SelectorUtility.selectPage(state.schoolOrgs, pageKey, page);
}

export function schoolOrgsTotal({ state, conditions, filters }) {
	var query = Queries.toQuery(filters, conditions);
	var totalKey = $wr.sortedJSON(query);
	return state.schoolOrgs.totals[totalKey];
}

//////////////////////////////////////////////
// Schools ///////////////////////////////////
//////////////////////////////////////////////

export function primarySchool({ state, filters, conditions }) {
	var schools = SelectorUtility.allRecords(state.schools);
	return _.first(schools);
};

export function school({ state, canonicalID, id }) {
	if (id) {
		return state.schools[id];
	}
	if (canonicalID) {
		return schools({ state, filters: { canonical_id: canonicalID } })[0];
	}
};

export function schools({ state, filters, conditions }) {
	return SelectorUtility.filterBy(state.schools, filters, conditions);
};

export function isLoadingSchool({ state, key }) {
	key = key || "index";
	return state.schools.loading[key];
}

//////////////////////////////////////////////
// Parents //////////////////////////////////
//////////////////////////////////////////////

export function parent({ state, id }) {
	return state.parents[id];
}

export function parents({ state, filters, conditions }) {
	var parents = SelectorUtility.filterBy(state.parents, filters, conditions);
	return _.sortBy(parents, studentSortName);
};

//////////////////////////////////////////////
// Students //////////////////////////////////
//////////////////////////////////////////////

// Gets all students (sorted by name)
export function students({ state, filters, conditions }) {
	var students = SelectorUtility.filterBy(state.students, filters, conditions);
	return _.sortBy(students, studentSortName);
};

export function student({ state, id }) {
	return state.students[id];
}

// Gets all students (sorted by name) with the provided student list ID
export function studentsForStudentListID({ state, studentListID }) {
	if (!(studentListID in state.studentLists) || !state.studentLists[studentListID] || state.studentLists[studentListID].length == 0) { return []; }

	var ss = [];

	_.each(students({ state }), (s) => {
		if (s.student_list_ids) {
			// Method used by teachers, admins
			if (s.student_list_ids.all.includes(studentListID)) {
				ss.push(s);
			}			
		} else {
			// Method used by students
			if (state.studentLists[studentListID].students && state.studentLists[studentListID].students.includes(s.id)) {
				ss.push(s);
			}
		}
	});
	
	return _.sortBy(ss, studentSortName);
}

// Gets all students (sorted by name) with the provided school org ID
export function studentsForSchoolOrgID({ state, schoolOrgID }) {
	if (!(schoolOrgID in state.schoolOrgs)) { return []; }

	var slIDs = _.pluck(studentLists({ state, filters: { school_org_id: schoolOrgID } }), "id");

	var ss = _.uniq(_.flatten(slIDs.map(
		(slID) => studentsForStudentListID({ state, studentListID: slID })
	)), "id");
	
	return _.sortBy(ss, studentSortName);
}

// Gets all students (sorted by name) in the subgroup matching this key
export function studentsForSubgroupKey({ state, subgroupKey }) {	
	return students({ state }).filter(s => ((s.prefs || {}).subgroup || {}).key === subgroupKey);
}

// Gets all students matching the org identifier string (see OrgTypes)
export function studentsForOrgIdentifier({ state, orgIdentifier }) {
	var { type, key } = OrgTypes.fromIdentifier(orgIdentifier);

	if (OrgTypes.isEveryoneIdentifier(type)) {
		return students({ state });

	} else if (type === OrgTypes.STUDENT_LIST) {
		return studentsForStudentListID({ state, studentListID: key });

	} else if (type === OrgTypes.SCHOOL_ORG) {
		return studentsForSchoolOrgID({ state, schoolOrgID: key });

	} else if (type === OrgTypes.SUBGROUP) {
		return studentsForSubgroupKey({ state, subgroupKey: key });

	} else {
		throw "Unrecognized org type " + type;
	}
}

// Gets all students (sorted by name) associate with the provided book
export function studentsForBookTextID({ state, textID }) {
	var book = ReadingSelectors.books({ state, conditions: { textID } })[0];
	if (!book) { return []; }

	var studentIDs = book.user_ids || book.students;
	if (!studentIDs) { return []; };
	
	return _.sortBy(_.pick(state.students, studentIDs), studentSortName);
}

// Gets all student list IDs mapped to list of students (sorted by name)
export function studentsByStudentListID({ state }) {
	var studentListIDs = _.pluck(state.studentLists, "id");
	return _.object(_.map(studentListIDs, (studentListID) => {
		return [studentListID, studentsForStudentListID({ state, studentListID })]
	}));
}

export function getSampleActiveStudent({ state }) {
	var activeStudents = _.select(students({ state }), (student) => {
		return student.last_active != undefined;
	})

	return _.first(_.sortBy(activeStudents, "first_name"));
}

export function getTeacherDemoStudent({ state }) {
	return _.findWhere(students, { demo_for_teacher: true });
}

export function isLoadingStudents({ state, key }) {
	key = key || "index";
	return state.students.loading[key];
}

export function hasNoStudents({ state }) {
	return (!isLoadingStudentLists({ state })) && 
		(!isLoadingStudents({ state })) &&
		(students({ state }).length == 0);
}

export function studentTaskCount({ state, studentID }) {
	var st = student({ state, id: studentID });

	var count = 0;

	if (st && st.current_tasks) {
		// Assigned exericises + texts... but just the IDs, note
		count += st.current_tasks.length;
	}

	if (st && st.all_tasks) {
		count += st.all_tasks.length;
	}
	
	var revisables = ReadingSelectors.booksWithRevisables({
		state, conditions: { userID: studentID }
	})

	count += revisables.length;

	return count;
}

//////////////////////////////////////////////
// OrgIdentifier stuff ///////////////////////
//////////////////////////////////////////////


// Org identifier matching student IDs, if any. Null otherwise
export function orgIdentifierForStudents({ state, studentIDs }) {
	studentIDs = _.uniq(studentIDs);
	var stdnts = students({ state });

	if (studentIDs.length == stdnts.length) {
		return OrgTypes.toIdentifier({ type: OrgTypes.ALL_STUDENTS });
	}

	var sls = studentLists({ state });
	for (var i = 0; i < sls.length; i++) {
		if (_.isEqual(_.sortBy(studentIDs), _.sortBy(sls[i].students))) {
			return OrgTypes.toIdentifier({
				type: OrgTypes.STUDENT_LIST,
				key: sls[i].id
			});
		}
	}

	var sbgrps = subgroups({ state });
	for (var i = 0; i < sbgrps.length; i++) {
		var subgroupIDs = stdnts.filter(s => ((s.prefs || {}).subgroup || {}).key === sbgrps[i].key);
		if (_.isEqual(_.sortBy(studentIDs), _.sortBy(subgroupIDs))) {
			return OrgTypes.toIdentifier({
				type: OrgTypes.SUBGROUP,
				key: sbgrps[i].key
			});
		}
	}

	return null; // No match
}

// Gets all students matching the org identifier string (see OrgTypes)
export function nameForOrgIdentifier({ state, orgIdentifier, fallback }) {
	if (!orgIdentifier && fallback) {
		return fallback;
	}

	var { type, key } = OrgTypes.fromIdentifier(orgIdentifier);

	if (type === OrgTypes.ALL_STUDENTS) {
		return "All Students";

	} else if (type === OrgTypes.ALL_STUDENT_LISTS) {
		return "All Classes";

	} else if (type === OrgTypes.ALL_SCHOOL_ORGS) {
		return "All Schools";

	} else if (type === OrgTypes.STUDENT_LIST) {
		return (studentList({ state, id: key }) || { name: fallback }).name;

	} else if (type === OrgTypes.SCHOOL_ORG) {
		return (schoolOrg({ state, id: key }) || { name: fallback }).name;

	} else if (type === OrgTypes.SUBGROUP) {
		return (subgroup({ state, key: key }) || { name: fallback }).name;

	} else {
		throw "Unrecognized org type " + type;
	}
}

//////////////////////////////////////////////
// Subgroups (Not a real model) //////////////
//////////////////////////////////////////////

export function subgroups({ state }) {
	var allSubGroups = students({ state }).map(
		(s) => (s.prefs || {}).subgroup
	).filter(
		(g) => !_.isEmpty(g)
	);
	return _.uniq(allSubGroups, false, (group) => group.key);
}

export function subgroup({ state, key }) {
	return _.findWhere(subgroups({ state }), { key });
}


////////////////////////////////////////
// Upgrade Tokens //////////////////////
////////////////////////////////////////

export function upgradeTokens({ state, filters, conditions }) {
	return SelectorUtility.filterBy(state.upgradeTokens, filters, conditions);
};
export function isLoadingUpgradeTokens({ state, key }) {
	key = key || "index";
	return state.upgradeTokens.loading[key];
}

////////////////////////////////////////
// Discount Tokens /////////////////////
////////////////////////////////////////

export function discountToken({ state, code }) {
	return state.discountTokens[code];
}
export function discountTokens({ state, filters, conditions }) {
	return SelectorUtility.filterBy(state.discountTokens, filters, conditions);
};

////////////////////////////////////////////////////
// Utility functions ///////////////////////////////
////////////////////////////////////////////////////

// Sort student by "Last, First" unless they are using a filler last name
function studentSortName(st) {
	if (st.last_name == $wr.Constants.FILLER_LAST_NAME) {
		return st.first_name;
	} else {
		return st.last_name + ", " + st.first_name;
	}
}



// WEBPACK FOOTER //
// ./modules/lib/selectors/RosterSelectors.js